import { apiWithHeader } from "./api";
import { API_STATUS } from "./constant";
import { BACKEND_API_BASE_URL } from "../utilities/constant";
import { getUserAccessToken } from "../utilities/setting";
import { checkAuthSession } from "../views/dashboard/auth/auth-utils";

export const patchApiCall = async (url, params) => {

    await checkAuthSession();
    const token = await getUserAccessToken();
  
    const response = await apiWithHeader(BACKEND_API_BASE_URL, 'application/json', token)
    .patch(url, params)
    .catch(function (error) {
      if(error.response == undefined){
        var errorMsg = 'A network error occurred. This could be a CORS issue or a dropped internet connection.';
      }else{
        const dataMsg = error?.response?.data?.message ? String(error?.response?.data?.message) : '';
        const explanationMsg = error?.response?.data?.message ? String(error?.response?.data?.message) : String(error?.response?.data?.error?.explanation);
        var errorMsg = '';
        if (dataMsg && explanationMsg) {
          if (dataMsg === explanationMsg) {
            errorMsg = dataMsg;
          } else {
            errorMsg = `${dataMsg} ${explanationMsg}`;
          }
        } else {
          errorMsg = dataMsg || explanationMsg || 'Something went wrong';
        }
      }
      return Promise.reject(errorMsg);
    });
  
    if (response.status == API_STATUS.SUCCESS || response.status == API_STATUS.ACCEPED || response.status == API_STATUS.CREATED) {
        return response.data.data;
    } else {
        return Promise.reject(response.data);
    }

};

export const patchApiCallWithHeader = async(url, payload) => {

    await checkAuthSession();
    const accessToken = await getUserAccessToken();
  
    const response = await apiWithHeader(BACKEND_API_BASE_URL, 'application/json', accessToken)
    .patch(url, payload)
    .catch(async function (error) {
        if(error.response == undefined){
            var errorMsg = 'A network error occurred. This could be a CORS issue or a dropped internet connection.';
        }else{
            const dataMsg = error.response.data.message ? String(error.response.data.message) : '';
            var errorMsg = dataMsg
        }
        return errorMsg;
    });

    if (response.status == API_STATUS.SUCCESS || response.status == API_STATUS.ACCEPED) {
        return response.data.data;
    } else {
        return Promise.reject(response);
    }

};